import { UseFormSetError } from "react-hook-form";
import { IPutLicenseDTO } from "src/shared/types/companies.types";
import {
  usePutLicenseMutation,
  usePutPartnerMutation,
  usePutPartnerBankAccountMutation,
  usePostPartnerBankAccountMutation,
  usePostLicenseMutation,
} from "../api/partners";
import { getPostBankAccountDto, getPutPartnerDTO } from "../helpers/helpers";
import { IEditPartnerFormValues } from "../types/partner";

interface IUseUpdatePartnerProps {
  partner_id: string;
  setError: UseFormSetError<IEditPartnerFormValues>;
}
export function useUpdatePartner({ partner_id }: IUseUpdatePartnerProps) {
  const [putLicense, { isLoading: isLoadingPutLicense }] =
    usePutLicenseMutation();
  const [postLicense, { isLoading: isLoadingPostLicense }] =
    usePostLicenseMutation();

  const [putPartner, { isLoading: isLoadingPutPartner }] =
    usePutPartnerMutation();

  const [putBankAccount, { isLoading: isLoadingPutBankAccount }] =
    usePutPartnerBankAccountMutation();
  const [postBankAccount, { isLoading: isLoadingPostBankAccount }] =
    usePostPartnerBankAccountMutation();

  const isLoading =
    isLoadingPutLicense ||
    isLoadingPutPartner ||
    isLoadingPutBankAccount ||
    isLoadingPostBankAccount ||
    isLoadingPostLicense;
  async function updatePartner({
    data,
    shouldUpdateLicense,
    shouldUpdateBankAccount,
    shouldUpdatePartner,
    shouldCreateLicense,
    shouldCreateBankAccount,
  }: {
    data: IEditPartnerFormValues;
    shouldUpdateLicense: boolean;
    shouldUpdateBankAccount: boolean;
    shouldUpdatePartner: boolean;
    shouldCreateLicense: boolean;
    shouldCreateBankAccount: boolean;
  }) {
    const { license, bank_account, partner } = data;
    const promises = [];
    if (shouldCreateBankAccount) {
      promises.push(
        postBankAccount({
          bank_account: getPostBankAccountDto(bank_account),
          partner_id,
        }).unwrap(),
      );
    }
    if (shouldUpdateBankAccount && bank_account.id) {
      promises.push(
        putBankAccount({
          bank_account: {
            ...getPostBankAccountDto(bank_account),
            id: bank_account.id,
          },
          partner_id,
        }).unwrap(),
      );
    }
    if (shouldCreateLicense && license) {
      promises.push(
        postLicense({
          license: {
            issued_by: license.issued_by,
            issued_date: license.issued_date?.format() || "",
            number: license.number,
          },
          partner_id,
        }).unwrap(),
      );
    }
    if (shouldUpdateLicense && license && typeof license.id === "number") {
      const putLicenseDto: IPutLicenseDTO = {
        id: license.id,
        issued_by: license.issued_by,
        issued_date: license.issued_date?.format() || "",
        number: license.number,
      };

      promises.push(
        putLicense({
          license: putLicenseDto,
          partner_id,
        }).unwrap(),
      );
    }
    if (shouldUpdatePartner) {
      promises.push(putPartner(getPutPartnerDTO(partner)).unwrap());
    }

    return Promise.all(promises);
  }

  return { updatePartner, isLoading };
}
